import { useTranslation } from "react-i18next";
import format from "date-fns/format";

import ContentItem from "components/common/InfoPopup/ContentItem";
import ContentSection from "components/common/InfoPopup/ContentSection";
import { FORMAT_DATE } from "constants/time";

export default function CompanyData({ companyData }) {
    const { t } = useTranslation();
    const creationDate =
        companyData.creation_date || (companyData.company && companyData.company.creation_date);

    return (
        <ContentSection>
            <ContentItem
                title={t("company.company_name")}
                value={companyData.name || (companyData.company && companyData.company.name) || "-"}
            />
            <ContentItem
                title={t("company.address")}
                value={
                    companyData.legal_address ||
                    (companyData.company && companyData.company.legal_address) ||
                    "-"
                }
            />
            <ContentItem
                title={t("company.contact_name")}
                value={
                    [companyData.lastname, companyData.firstname, companyData.middlename]
                        .filter(Boolean)
                        .join(" ") || "-"
                }
            />
            <ContentItem
            title={t("company.phone")}
            value={
                (() => {
                const phone =
                    companyData.phone ||
                    (companyData.company && companyData.company.phone);

                if (!phone) return "";

                const formattedPhone = phone.startsWith("+") ? phone : `+${phone}`;

                return (
                    <a href={`tel:${formattedPhone}`} className="text-blue-600 hover:underline">
                    {formattedPhone}
                    </a>
                );
                })()
            }
            />
            <ContentItem
                title={t("company.legal_form")}
                value={
                    companyData.legal_form ||
                    (companyData.company && companyData.company.legal_form) ||
                    "-"
                }
            />
            <ContentItem
                title={t("company.payer_number")}
                value={
                    companyData.payer_number ||
                    (companyData.company && companyData.company.payer_number) ||
                    "-"
                }
            />
            {creationDate && (
                <ContentItem
                    title={t("company.founding_date")}
                    value={format(new Date(creationDate), FORMAT_DATE)}
                />
            )}
            <ContentItem
            title={t("company.site")}
            value={
                (() => {
                const site = companyData.site
                            || (companyData.company && companyData.company.site) ||
                            "-";

                const formattedSite = site.startsWith("http")
                ? site
                : `https://${site}`;

                const urlWithUtm = `${formattedSite}?utm_source=blago.pro`;

                return (
                <a
                    href={urlWithUtm}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline"
                >
                    {formattedSite.replace(/^https?:\/\//, "")}
                </a>
                );
                })()
            }
            />
        </ContentSection>
    );
}
